import React from 'react'

const Footer = () => {
    return (
        <>
            <div className='py-5 bg-blue-400 mt-8 print:hidden'>
                <p className='font-bold text-center text-xl'>Copyright © {new Date().getFullYear()}  FIVE SEVEN I.T. SOLUTIONS PVT LTD || ALL RIGHTS RESERVED.</p>
            </div>
        </>
    )
}

export default Footer